import { formatDate } from '@utils/formatter';
import PaymentBubble from '../PaymentBubble';
import { PaymentBubbleCommonProps } from '../types';

export default function RequestRenewalBubble({
  chatMessage,
  history
}: PaymentBubbleCommonProps) {
  const postponedPayApproveDate = formatDate(
    chatMessage?.rfq?.expectedConfirmPurchaseDate ?? 0,
    'YYYY.MM.DD'
  );

  const onClickButton = () => {
    if (!history) return;
    const { pathname } = history.location;
    history.push(`${pathname}?menu=purchaseorder`);
  };

  return (
    <PaymentBubble>
      <PaymentBubble.Title>구매확정 기간을 연장했습니다.</PaymentBubble.Title>
      <PaymentBubble.Stepper activeStep={3} />
      <PaymentBubble.Content>
        {postponedPayApproveDate}까지 구매확정을 완료해주세요. 기한까지
        구매확정이 완료되지 않으면 이후 자동 구매확정됩니다.
      </PaymentBubble.Content>
      <PaymentBubble.Button buttonAction={onClickButton}>
        제조현황 확인
      </PaymentBubble.Button>
    </PaymentBubble>
  );
}
